<template>
    <vue-draggable-resizable class="tag"
      :w="size.width" :h="size.height" :x="axis.x" :y="axis.y" :z-index="9"
      :draggable="false" :resizable="false"> 
        <div v-if="value.type === 'text-employer'" class="field-input-wrap">
            <v-text-field v-model="content" readonly flat solo hide-details class="v-input--small" />
        </div>
        <div v-if="value.type === 'text-employee'" class="field-input-wrap">
            <v-text-field v-model="content" readonly flat solo hide-details class="v-input--small" />
        </div>
        <div v-if="value.type === 'check'" class="field-input-wrap">
            <div class="checkbox-wrap">
                <v-checkbox v-model="content" readonly :ripple="false" hide-details/>
            </div>             
        </div>
        <!-- <div v-if="value.type === 'file'">
            <v-file-input v-model="content"/>
        </div> -->
        <div v-if="value.type === 'canvas'" class="field-input-wrap">
            <v-img :src="value.content" readonly hide-details></v-img>
        </div>
    </vue-draggable-resizable>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'
// import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

export default {
  components:{
    VueDraggableResizable
    },
    props:{
        value: { type: Object, default: ()=>({}) }
    },
    data(){
        return{
            axis: {
                x: this.value?.axis?.x || 0,
                y: this.value?.axis?.y || 0,
            },
            size: {
                width: this.value?.size?.w || 100,
                height: this.value?.size?.h || 50,
            },
            content: this.value?.content || null,

            //canvas
            show: false,
            x: 0,
            y: 0,
            isDrawing: false
        }               
    },
}
</script>

<style scoped>
.tag{
    position: absolute;
}
</style>